import slugify from "slugify";
import Decimal from "decimal.js";
import router from "@/plugins/router";


export function arrayToParams (paramsArr) {
    let params = {}
    for (const param of paramsArr) {
        if (!param)
            continue
        let split = param.split('-')
        let key = split[0]
        // noinspection UnnecessaryLocalVariableJS
        let val = split.slice(1).join("-")

        params[key] = val
    }
    return params
}

function parseUrlSlashParamsStr(paramsStr) {
    let urlParams = {}
    if (paramsStr) {
        let trainingParamsArr = paramsStr.split('/')
        urlParams = arrayToParams(trainingParamsArr)
    }
    return urlParams
}

function toUrlSlashParamsStr(params) {
    let res = ''
    for (let key in params)
        // noinspection JSUnfilteredForInLoop
        res += '/' + key + '-' + params[key]
    return res
}

export function getTrainingParticipantsqty(training) {
    if (training.boatType)
        return parseInt(training.boatType[4])
    else
        return 1
}

export function getTrainingParticipantName(training, seatNum) {
    let participant = training['participant' + seatNum]
    let participantCustomName = training[`participant${seatNum}CustomName`]
    if (participant)
        return participant.username
    else if (participantCustomName)
        return participantCustomName
    return null
}


export function getTrainingParamsFromUrlPartOrArr(arrOrStr) {
    if (arrOrStr)
        if (typeof arrOrStr === 'string')
            return parseUrlSlashParamsStr(arrOrStr)
        else
            return arrayToParams(arrOrStr)
    else return {}
}


export function getTrainingParamsFromVars(training, currentUser, activeTab, time) {
    let params = {}
    if (time)
        params['time'] = time.toFixed(2) + 's'
    if (training.owner.id !== currentUser.id) {
        params['by'] =  training.owner.username
    }
    if (getTrainingParticipantsqty(training)) {
        let participantName = getTrainingParticipantName(training, 1)
        if (participantName && participantName !== currentUser.username && participantName !== training.owner.username)
            params['athlete'] = slugify(participantName)
    }

    params['from'] =  currentUser.username
    return params
}

export function getTrainingParamsUrlPart(trainingParams)
{
    return toUrlSlashParamsStr(trainingParams)
}

export function getTrainingParamsArrForUrl(trainingParams)
{
    return getTrainingParamsUrlPart(trainingParams).slice(1).split('/')
}

export function getTimeDecimalFromTrainingParams(trainingParams) {
    if ('time' in trainingParams) {
        let decimalStr = trainingParams['time'].slice(0, trainingParams['time'].length-1)
        return new Decimal(decimalStr)
    }
    return null
}

export function generateTrainingUrl(training, user, activeTab, reportSrcVideoTime= 0) {
    const paramFromVars = getTrainingParamsFromVars(training, user, activeTab, reportSrcVideoTime),
        paramsForUrl = getTrainingParamsArrForUrl(paramFromVars);

    return window.location.protocol + '//' + window.location.host + router.resolve({
            name: 'training',
            params: {trainingId: training.id, activeTab: activeTab, trainingParams: paramsForUrl},
        }
    ).href
}